<p-table
	#dt
	[value]="venueService.ooCanvases[this.canvasIndex].menuItems"
	styleClass="p-datatable-responsive-demo"
	dataKey="menuItemKey"
	[globalFilterFields]="app.keys(venueService.ooCanvases[this.canvasIndex].menuItems)"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<span class="p-float-label p-input-icon-left m-2 flex-grow-1">
				<i class="pi pi-search"></i>
				<input
					pInputText
					class="w-100"
					id="globalSearch"
					name="globalSearch"
					style="width: 100%"
					type="text"
					(input)="dt.filterGlobal($event.target.value, 'contains')"
				/>
				<label for="globalSearch">Search...</label>
			</span>
			<div class="mx-2 mt-2">
				<p-button pRipple styleClass="p-button-raised p-button-primary" (click)="onAddItem()">
					<ng-template pTemplate="content">
						<div class="d-flex justify-content-center">
							<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1 me-2"></fa-icon>
							Add Subscription Item
						</div>
					</ng-template>
				</p-button>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th>Name</th>
			<th>Subscription Price</th>
			<th>Currently Available</th>
			<th>Frequencies</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr (click)="onSelectItem(rec)">
			<td>
				<span class="p-column-title"> Name </span>
				{{ rec.displayName || rec.ooMenuItem.name }}
			</td>
			<td>
				<span class="p-column-title"> Subscription Price </span>
				{{ venueService.menuItemGetPriceFromNumber(rec.ooMenuItem, rec.ooMenuItem.subscriptionPriceNumber) | currency }}
			</td>
			<td>
				<span class="p-column-title"> Currently Available </span>
				<p-inputSwitch [disabled]="true" [(ngModel)]="rec.online"></p-inputSwitch>
			</td>
			<td>
				<span class="p-column-title"> Frequencies </span>
				<div class="d-flex">
					<ng-container *ngFor="let freq of rec.subscriptionFrequencyDisplayName">
						{{ freq }}
					</ng-container>
				</div>
			</td>
		</tr>
	</ng-template>
</p-table>

<p-dialog
	*ngIf="subscriptionItemSelected"
	[(visible)]="subscriptionItemSelected"
	[breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
	[style]="{ width: '50vw' }"
>
	<ng-template pTemplate="header">
		<div class="d-flex flex-column w-100">
			<div class="h3">Subscription Item</div>
			<div class="descriptionText">
				Subscription items are items that you sell on a set subscription basis (i.e. weekly, monthly etc.). Customers can sign up for Subscriptions.
				These subscriptions will be automatically charged and transactions created in-store based on the frequency.
			</div>
		</div>
	</ng-template>
	<form #subscriptionItemForm="ngForm">
		<div class="d-flex flex-column w-100">
			<div class="d-flex">
				<div class="flex-fill mt-4">
					<span class="p-float-label">
						<p-dropdown
							required
							#menuItemList
							[options]="venueService.ooMenuItems | arrayFilter : { subscriptionItem: true }"
							optionLabel="name"
							optionValue="menuItemKey"
							name="venueService.ooMenuItems"
							[(ngModel)]="subscriptionItemSelected.menuItemKey"
							[style]="{ width: '100%' }"
							appendTo="body"
							[autoDisplayFirst]="false"
							[virtualScroll]="true"
							virtualScrollItemSize="30"
							filter="true"
							filterBy="filterByProperties"
							(onChange)="onSetSelectedMenuItem()"
						>
							<ng-template pTemplate="empty"> No subscription items found. </ng-template>
						</p-dropdown>
						<label for="menuItemList">Subscription Item</label>
					</span>
				</div>
				<div class="mx-1 flex-fill mt-4">
					<span class="p-float-label">
						<input
							pInputText
							required
							#subscriptionDisplayName
							name="subscriptionDisplayName"
							type="text"
							[(ngModel)]="subscriptionItemSelected.displayName"
							class="w-100"
						/>
						<label for="subscriptionDisplayName">Display Name</label>
					</span>
				</div>
			</div>
			<div class="d-flex flex-wrap">
				<div class="flex-fill mx-1 mt-4">
					<span class="p-float-label">
						<p-dropdown
							required
							#subscriptionItemPriceNumberSelect
							[disabled]="!subscriptionItemSelected.ooMenuItem"
							[options]="venueService.menuItemPriceOptions(subscriptionItemSelected?.ooMenuItem)"
							optionLabel="label"
							optionValue="value"
							name="subscriptionItemPriceNumberSelect"
							[(ngModel)]="subscriptionItemSelected.priceNumber"
							[style]="{ width: '100%' }"
							appendTo="body"
							[autoDisplayFirst]="false"
						></p-dropdown>
						<label for="subscriptionItemPriceNumberSelect">Subscription Price</label>
					</span>
				</div>

				<div class="mx-1 flex-fill mt-4">
					<span class="p-float-label">
						<p-multiSelect
							#subscriptionItemFrequency
							[options]="subscriptionItemSelectedAvailableFrequencies"
							optionDisabled="disabled"
							optionLabel="label"
							optionValue="value"
							name="subscriptionItemFrequency"
							[(ngModel)]="subscriptionItemSelected.subscriptionAllowedFrequencies"
							[style]="{ width: '100%' }"
							appendTo="body"
						></p-multiSelect>
						<label for="subscriptionItemFrequency">Allowed Frequency</label>
					</span>
				</div>
			</div>
			<div class="d-flex mt-4 w-100">
				<span class="p-float-label w-100">
					<textarea
						pInputTextarea
						#subscriptionItemDescription
						name="subscriptionItemDescription"
						[(ngModel)]="subscriptionItemSelected.description"
						class="w-100 mt-1"
					></textarea>
					<label for="subscriptionItemDescription">Description</label>
				</span>
			</div>
			<div class="d-flex mt-4 w-100">
				<div class="d-flex mx-2">
					<div class="my-auto me-2">Available</div>

					<p-inputSwitch name="subscriptionItemSelectedOnline" [(ngModel)]="subscriptionItemSelected.online"></p-inputSwitch>
				</div>
			</div>
		</div>
	</form>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			(onSaveChange)="onItemSave()"
			[saveDisabled]="subscriptionItemForm.invalid"
			(onCancelChange)="subscriptionItemSelected = undefined"
			(onDeleteChange)="onItemDelete()"
			[deleteDisabled]="subscriptionItemSelected.unsaved"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
